export function RangeCard({ range, active }) {
  const lifecycleStatus = range.lifecycle?.status || range.status || "active";

  return (
    <article className={`range-card ${active ? "is-active" : ""}`}>
      <div>
        <h3>{range.name}</h3>
        <p>{range.slug}.rangegrid.app</p>
      </div>
      <div className="range-card-badges" aria-label="Range status and access">
        <span className={`status-badge status-${lifecycleStatus}`}>{lifecycleStatus}</span>
        <span className="status-badge access-badge">{range.access?.role || "owner"}</span>
      </div>
    </article>
  );
}
